export default __webpack_public_path__ + "static/media/Zinger ERP- C.b8ee2b8e.webp";